export default __webpack_public_path__ + "static/media/beast-tamer.fad7c17e.png";